import { CardProps, Typography } from '@material-ui/core';
import { CardX } from 'framework/components/cards/CardX';
import { IHealthInsuranceFundWithAddressDto } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { HifDetailsContent } from './HifDetailsContent';

interface IProps extends CardProps {
	reload: VoidFunction;
	item: IHealthInsuranceFundWithAddressDto;
}

export const HifDetailsCard = ({ item, reload, ...rest }: IProps) => {
	const strings = useLocalization();

	return (
		<CardX {...rest}>
			<Typography
				component='div'
				style={{ fontSize: '16px', fontWeight: 500, marginBottom: 16 }}>
				{`${strings.detailsOfHif}: ${item.name}`}
			</Typography>
			<HifDetailsContent
				item={item}
				reload={reload}
			/>
		</CardX>
	);
};
